import { useEffect, useContext, useState } from 'react';
import styled from 'styled-components';
import AppContext from '../../../context/HeaderContext';
import { getAPI } from '../../../libs/fetchAPI';
import Loading from '../../../components/Loading';

const InfoLabel = styled.p`
	margin: 7px 0 3px 0;
	color: gray;
	font-weight: 700;
`;

function Info() {
	const { user }                = useContext(AppContext);
	const [ loading, setLoading ] = useState(true);
	const [ info, setInfo ]       = useState({});

	/* eslint-disable */
	useEffect(() => {
		setLoading(true);

		getAPI(`/users/${user.id}`)
			.then(({ data }) => {
				setInfo(data[0]);
				setLoading(false);
			});
	}, []);
	/* eslint-enable */

	if(loading) {
		return <Loading />
	}

	return (
		<>
			<InfoLabel>Name</InfoLabel>
			<p>{info.first_name} {info.last_name}</p>

			<InfoLabel>Email</InfoLabel>
			<p>{info.email}</p>
		</>
	)
}

export default Info;
